import Migrating from "../../../../src/courses/partials/migrating.mdx";
import * as React from 'react';
export default {
  Migrating,
  React
};